<template>
  <div class="homepage">
    <ApolloQuery :query="require('@/graphql/Home.gql')"
                 :variables="{
                    today: today
                  }"
    >
      <template slot-scope="{ result: { error, data, loading }, isLoading }">

        <!--
           Jumbotron, block "about", and dropdown to go the the pathology form
        -->
        <about/>

        <row class="u-bg--grey">

          <!-- News -->
          <div class="col-lg-8">
           <actualites v-if="data" :news="data.infos.edges"></actualites>
            <div v-if="isLoading"><loading/> </div>
            <div v-if="error"><error/></div>
          </div>

          <!-- studies -->
          <aside class="col-lg-4">
            <card-study v-if="data" :study="data.studies.edges[0]" :flatButton="true"></card-study>
            <div v-if="isLoading"><loading/></div>
            <div v-if="error"><error/></div>
          </aside>
        </row>

      </template>
    </ApolloQuery>

    <!-- Partners -->
    <Partners />
  </div>
</template>

<script>
import Actualites from './../components/Card/Models/Card-multiple-actu'
import CardStudy from './../components/Card/Models/Card-study'
import Row from './../components/Layout/Row'
import About from "../components/About/About";
import Partners from '../components/Footer/Partners';
import Error from "../components/Core/Error";
import Loading from "../components/Core/Loading";

export default {
  name: 'homepage',
  components: {
    Loading,
    Error,
    About,
    Actualites,
    CardStudy,
    Row,
    Partners
  },
  data: () => {
    return {
      today: ''
    }
  },
  mounted() {
    this.today = new Date();
    document.title = "Application des recommandations de bonne pratique en dermatologie de la SFD";
  }
}
</script>

<style lang="scss">
  .homepage {
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 1440px;

    .card-study {
      height: 100%;

      .card-container {
        height: 100%;
      }
    }
  }
</style>
